<template>
  <section>
    <section-header
      @toggle="showSection = !showSection"
      :showSection="showSection"
      :section="section">
      <slot></slot>
      <new-item slot="add" :section="section" v-if="canEdit"></new-item>
    </section-header>

    <div class="content" v-show="showSection && items.length > 0">
      <h6 v-if="['PF Playtest', 'PFRPG2', 'Embers RPG'].includes(ruleset)">Bulk: {{$rulesets[ruleset].getCarriedWeight(items)}}</h6>
      <h6 v-else>Total Weight: {{$rulesets[ruleset].getCarriedWeight(items)}} lb</h6>

      <item class="item-row"
        v-for="item in noType"
        :item="item"
        :section="section"
        @setId="editId = item._id"
        :key="item._id">
      </item>

      <div v-for="itemCategory in this.$rpgv.itemTypes.filter(x => x !== '')" :key="itemCategory">
        <h6 v-if="itemsSorted(itemCategory).length > 0" class="rule">{{itemCategory}}</h6>
        <div v-if="itemCategory !== 'Currency'">
          <item
            class="item-row rule-indent"
            v-for="item in itemsSorted(itemCategory)"
            :item="item"
            :section="section"
            @setId="editId = item._id"
            :key="item._id">
          </item>
        </div>
        <div v-else>
          <item
            class="item-row rule-indent"
            v-for="item in itemsNotSorted(itemCategory)"
            :item="item"
            :section="section"
            @setId="editId = item._id"
            :key="item._id">
          </item>
        </div>
      </div>
    </div>

    <ez-modal v-if="showEditModal" @close="closeEdit(editItem)" size="m-medium">
      <default
        :section="section" 
        :item="editItem">
      </default>
      <clone-delete-item
        :section="section"
        :item="editItem"
        @close="closeEdit(editItem)">
      </clone-delete-item>
    </ez-modal>

  </section>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Item from "./_Item.vue";
import CloneDeleteItem from "../shared/_CloneDeleteItem.vue";
import Default from "./_Default.vue";
import NewItem from "./_New.vue";
import SectionHeader from "../shared/_SectionHeader.vue";
import modal from "@/mixins/vue-ez-modal";

export default {
  name: "sheet-items-index",
  mixins: [modal],
  components: {
    Item,
    NewItem,
    CloneDeleteItem,
    Default,
    SectionHeader,
  },
  data() {
    return {
      section: "items",
      editId: null,
      editItem: null,
      showSection: true,
      showEditModal: false,
    };
  },
  watch: {
    editId: "showEdit",
  },
  computed: {
    ...mapState({
      user: (state) => state.session.user,
      ruleset: (state) => state.characters.current.ruleset,
      items: (state) => state.characters.current.items,
    }),
    ...mapGetters({
      canEdit: "characters/canEdit",
    }),
    noType() {
      let _refs = this.items.filter(
        (x) => x.type === null || x.type === "" || x.type === undefined
      );
      return _refs.sort(function (a, b) {
        let nameA = a.name ? a.name.toUpperCase() : ""; // ignore upper and lowercase
        let nameB = b.name ? b.name.toUpperCase() : ""; // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });
    },
  },
  methods: {
    ...mapActions({
      createItem: "characters/createItem",
      itemsPatch: "items/patch",
    }),
    closeEdit(item) {
      this.patchData(item);
      this.showEditModal = false;
      this.editId = null;
    },
    showEdit() {
      if (this.editId) {
        this.editItem = this.items.find((x) => x._id === this.editId);
        this.showEditModal = true;
      }
    },
    itemsNotSorted(v) {
      return this.items.filter((x) => x.type === v);
    },
    itemsSorted(v) {
      let items = this.items.filter((x) => x.type === v);
      return items.sort(function (a, b) {
        let nameA = a.name ? a.name.toUpperCase() : ""; // ignore upper and lowercase
        let nameB = b.name ? b.name.toUpperCase() : ""; // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });
    },
    async patchData(item) {
      if (this.canEdit && item._ref && !item.stock) {
        try {
          let ref = Object.assign({}, item);
          ref._id = ref._ref._id;
          delete ref._ref;
          this.itemsPatch(ref);
        } catch (err) {
          console.error(err);
          this.errors = Object.assign({}, this.errors, err.response.data);
        }
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.content
  padding-top: .3em
</style>
